<ng2-completer #completerWidget
               class="completer-limit"
               [datasource]="dataService"
               [minSearchLength]="0"
               [inputClass]="'form-control border-no-radius'"
               [openOnFocus]="true"
               [autoHighlight]="true"
               [selectOnFocus]="true"
               [fillHighlighted]="false"
               [(ngModel)]="value"
               (selected)="onSelected($event)"
               (opened)="onOpened($event)"
               (click)="onClick()"
               (focus)="openCloseFocused = true"
               (blur)="openCloseFocused = false; propagateTouch(completerWidget)">
</ng2-completer>
